<template>
  <div class="details-page__bottom-button">
    <div class="flex items-end flex-wrap py-4">
      <div class="flex gap-2 items-end flex-grow price">
        <span
          class="lg:text-3xl text-xl"
          itemprop="priceSpecification"
          itemscope
          itemtype="https://schema.org/UnitPriceSpecification"
        >
          <ClientOnly><meta itemprop="price" :content="price"></ClientOnly>
          {{ price }}</span>
      </div>
      <span class="text-brand-black/50">IVA {{ $t('included') }}</span>
    </div>

    <BaseButton
      size="xl"
      type="button"
      class="w-full"
      :disabled="loading"
      :loading="loading"
      @click="emit('submit')"
    >
      {{ $t('continue') }}
    </BaseButton>
  </div>
</template>

<script setup lang="ts">
import BaseButton from '~/components/BaseButton.vue';

interface Props {
  price: string
  loading: boolean
}

defineProps<Props>();

const emit = defineEmits(['submit']);
</script>

<style scoped>
.details-page__bottom-button {
  @apply sticky bottom-0 z-10 px-6 pb-4 bg-brand-white lg:hidden;
}
</style>
